import React from 'react';
import cls from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ReactComponent as Wallet } from '../../../assets/svg/icons/wallet-04.svg';
import { ReactComponent as Hanger } from '../../../assets/svg/icons/hanger.svg';
import { IconComp } from '../IconComponent';
import { truncateAddress } from '../../../utils/truncateAddress';

interface INoNFTsContainer {
  inOpenSwapView?: boolean;
  className?: string;
  recipientAdress?: string;
  innerContentClass?: string;
}

export const NoNFTsContainer: React.FC<INoNFTsContainer> = (props) => {
  const { inOpenSwapView, className, recipientAdress, innerContentClass } = props;
  return (
    <div className={cls('xs-only:w-full bg-white border border-cloud-900 rounded-xl', className)}>
      <div className="flex flex-col items-center h-full">
        <IconComp className="fill-current text-onion-100 my-2 h-2" icon={Hanger} size={72} />
        <div className={cls('flex flex-col h-full justify-center items-center text-center', innerContentClass)}>
          <h4 className="text-lg text-cloud-900 mb-1">No NFTs selected</h4>
          <span className="text-base text-cloud-400">{props.children}</span>
        </div>
      </div>
      {inOpenSwapView && (
        <div className="text-tiny border-t border-cloud-900 items-center px-1 py-1 flex w-full bg-bkg-neutral-light">
          <IconComp icon={Wallet} size={24} />
          {recipientAdress && (
            <CopyToClipboard text={recipientAdress}>
              <span className="ml-1 hover:text-cloud-700 cursor-pointer text-base truncate max-w-full">
                {truncateAddress(recipientAdress)}
              </span>
            </CopyToClipboard>
          )}
        </div>
      )}
    </div>
  );
};
